var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"infoItem"}},[_c('div',{staticClass:"hidden-md-and-up"},[_c('m-top'),_c('div',[_c('div',{staticClass:"m-title"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"m-time"},[_vm._v(_vm._s(_vm.item.createTime))]),_c('div',{staticClass:"m-content"},[_vm._v(_vm._s(_vm.item.content))])]),_c('m-access'),_c('m-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }